import NseCelebrationAccessGate from './components/NseCelebrationAccessGate';
import NseCelebrationPage from './pages/NseCelebrationPage';

export default function NseCelebrationApp() {
  return (
    <NseCelebrationAccessGate>
      <NseCelebrationPage />
    </NseCelebrationAccessGate>
  );
}
